module.exports = __webpack_public_path__ + "static/media/ic-elipsis-h.2a6e2a3f.svg";